import { all, fork } from 'redux-saga/effects';
import { saga as signIn } from '../modules/auth/sign-in/saga';

export function* rootSaga() {
  yield all([
    fork(signIn),
  ]);
}
